import axios from 'axios';
import store from '@/store/';
import { API_BASE_URL } from '@/helpers/config';

const API = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

API.interceptors.request.use(
  (config) => {
    const $config = config;
    const $token = store.state.token;
    if ($token) {
      $config.headers.Authorization = `Bearer ${$token}`;
    }
    return $config;
  },

  (error) => {
    Promise.reject(error);
  },
);

export default API;
